// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"40790043","146":"57f8005d","180":"e4301ae2","349":"6fd8333f","377":"565e0778","413":"269e8935","424":"9efe4eee","453":"f2b619a6","554":"82893973","687":"e42b6e4f","813":"c936003a","821":"e26414c8","962":"c3d1604b","963":"2333c43f","989":"df8a32d4"}[chunkId] + ".chunk.js";
};